<template>
  <form novalidate class="form" @submit.prevent="$emit('submit')">
    <div class="form__alert"></div>

    <div class="form__body">
      <slot></slot>
    </div>

    <div class="form__footer">
      <slot name="footer"></slot>
    </div>
  </form>
</template>

<script>
export default {}
</script>
